<template>
  <div class="container pay_type">
    <div class="head_box">
      <div class="logo" v-if="false">
        <router-link to="/" target="_blank">
          <img class="img_item" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div>
    </div>
    <div class="content">
      <div class="top_box">
        <div>
          <p class="mrb15 order_itr">
            订单付款！订单号：
            <router-link class="order_a com_link" v-for="(item, index) in orderList" :key="index" :to="{
                  path: orderDetailPath,
                  query: { id: item.id },
                }" target="_blank">
              <span>{{
                  index === 0 ? "" + item.orderNo : "，" + item.orderNo
                }}</span>
            </router-link>
          </p>
          <p v-if="payStatus==1">
            请您在
            <span class="theme_color">
              <count-down :target="targetTime" :onEnd="timeEnd" />
            </span>
            内完成支付，否则订单会被自动取消
          </p>
        </div>
        <div class="flex tip_box">
          <p>应付金额：</p>
          <p class="price" v-if="stages.canEditPayFee === 0">
            ￥{{ payFee | priceValue }}
          </p>
          <el-input-number v-if="stages.canEditPayFee === 1" class="stage" size="mini" :controls='false' :precision='0' v-model="payFee" @blur="tipMinPrice" @keyup.native="limitValue">
          </el-input-number>
          <p v-if="stages.canEditPayFee === 1" class="stage_dw">元</p>
          <div class="tips" v-if="tipTest">
            <span v-html="tipTest"></span>
          </div>
        </div>
      </div>
      <div class="bottom_box">
        <div class="title">请选择支付方式</div>
        <div class="pay_item cur_pointer" :class="item.id === payWay ? 'active' : ''" v-for="(item, index) in payTypeData" :key="index" @click="payWay = item.id">
          <div class="circle"></div>
          <div class="img_box">
            <img :src="item.src" alt="图片加载失败" />
          </div>
          <div class="itr">
            (即时到账、支持绝大多数银行借记卡及部分银行卡在线支付)
          </div>
        </div>
        <div class="btn_box">
          <el-button type="primary btn" :disabled="payWay === 0 || btnDis" @click="goPay">立即支付</el-button>
        </div>
      </div>
      <div class="form_box" v-html="formHtml" v-show="false"></div>
    </div>
  </div>
</template>

<script>
import CountDown from "@/components/CountDown";
import onlyMessage from "@/pages/publicUtils/resetMessage.js";
export default {
  metaInfo: { title: "支付中心" },
  name: "orderPay",
  components: {
    CountDown,
  },
  props: {
    SingleGetOrderInfoToPay: {
      type: Function,
      default: () => {},
    },
    SingleGetOrderPayFeeInfo: {
      type: Function,
      default: () => {},
    },
    SinglePageOrderPay: {
      type: Function,
      default: () => {},
    },
    orderDetailPath: {
      type: String,
      default: "/personalCenter/myOrderDetail",
    },
  },
  data() {
    return {
      payTypeData: [
        { id: 1, src: require("@/assets/img/zhifub.jpg") },
        { id: 2, src: require("@/assets/img/weixin.jpg") },
      ],
      payWay: 0,
      orderList: [],
      id: "",
      orderNo: "",
      targetTime: 0,
      formHtml: "",
      btnDis: true,
      stages: {},
      payFee: 0,
      tipTest: undefined,
      payStatus: 0,
    };
  },
  mounted() {
    // console.log(this.$route.query);
    if (!this.$route.query.id) {
      return;
    }
    // id
    this.id = this.$route.query.id;
    // 订单号
    this.orderNo = this.$route.query.orderNo;
    // 展示数组
    let arrId = this.id.split(",");
    let arrNo = this.orderNo.split(",");
    arrId.forEach((v, i) => {
      this.orderList.push({
        id: v,
        orderNo: arrNo[i],
      });
    });
    this.getOrderInfo(this.id);
    this.getOrderPayFeeInfo(this.id);
  },
  methods: {
    getOrderInfo(orderId) {
      this.SingleGetOrderInfoToPay({ orderId }).then((res) => {
        // console.log("获取订单支付信息", res);
        let startTime = res.data[0].closeStartTime;
        let payExpire = res.data[0].payExpire * 1000;
        this.targetTime = Date.parse(startTime.replace(/-/g, "/"));
        this.targetTime += payExpire;
        this.btnDis = false;
        let arr = res.data[0].orderBatchList;
        for (let index = 0; index < arr.length; index++) {
          if (arr[index].payStatus == 1) {
            this.payStatus = 1;
            break;
          } else {
            this.payStatus = 0;
          }
        }
      });
    },
    getOrderPayFeeInfo(orderId) {
      this.SingleGetOrderPayFeeInfo({ orderId }).then((res) => {
        // console.log("（分期付款）", res);
        // res.data[0].canEditPayFee = 1
        this.stages = JSON.parse(JSON.stringify(res.data[0]));
        // Math.round解决误差 比例固定为整数
        this.stages.payRateStr = Math.round(this.stages.minPayRate * 100) + "%";
        this.payFee =
          Math.ceil(parseFloat(this.$route.query.totalAmount)) ||
          this.stages.needToPayFee;
      });
    },
    goPay() {
      if (this.stages.canEditPayFee === 1 && !this.payFee) {
        this.$alert("请输入金额", `支付失败`, {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      // 微信支付
      if (this.payWay === 2) {
        let newUrl = this.$router.resolve({
          path: "/wechatPay",
          query: {
            id: this.id,
            orderNo: this.orderNo,
            payFee: this.payFee,
            come: "order",
          },
        });
        window.open(newUrl.href, "_self");
        return;
      }
      // 支付宝支付
      let params = {
        payWay: this.payWay,
        orderId: this.id,
        payFee: this.payFee,
        callBackUrl: "/successPay?come=order",
        aloneDo: true,
      };
      this.SinglePageOrderPay(params).then((res) => {
        // console.log("执行网页扫描支付接口", res);
        if (res.isSuccess === 0) {
          onlyMessage.error(res.message || "发生异常");
        } else {
          var reg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          let str = res.replace(reg, "");
          // console.log(str);
          this.formHtml = str;
          this.$nextTick(() => {
            document.forms["submit"].submit();
          });
        }
      });
    },
    timeEnd() {
      this.btnDis = true;
      onlyMessage.error("支付超时，该订单已被取消");
    },
    tipMinPrice() {
      let val = this.payFee;
      // 小于
      if (val < this.stages.minPayFee || !val) {
        this.payFee = this.stages.needToPayFee;
        this.btnDis = false;
        // 控制显示比例 尾款不显示比例
        let minP = this.stages.totalPayFee * this.stages.minPayRate;
        // 保留6位小数减小误差
        minP = minP.toFixed(6);
        minP = parseFloat(minP);
        if (minP > this.stages.minPayFee) {
          this.tipTest = `<span>最低应付金额</span><span style="color:#ff0000">￥${this.stages.minPayFee}</span>`;
        } else {
          this.tipTest = `<span>最低付款比例${this.stages.payRateStr}</span><br />
                <span>最低应付金额</span><span style="color:#ff0000">￥${this.stages.minPayFee}</span>`;
        }
      } else if (
        //符合
        val >= this.stages.minPayFee &&
        val <= this.stages.needToPayFee
      ) {
        this.tipTest = undefined;
        this.btnDis = false;
      } else {
        //大于
        this.tipTest = `<span>最高应付金额<span style="color:#ff0000">￥${this.stages.needToPayFee}</span></span>`;
        this.btnDis = true;
      }
    },
    limitValue(e) {
      if (e.key === ".") {
        this.payFee = e.target.value.substr(0, e.target.value.indexOf("."));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pay_type {
  .head_box {
    margin-top: 37px;
    margin-bottom: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
  }
  .content {
    width: 100%;
    height: 820px;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    padding: 46px 24px;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 120px;
    .top_box {
      padding: 0px 100px 60px 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      position: relative;
      .order_itr {
        max-width: 722px;
        word-wrap: break-word;
        .order_a {
          color: #1a1a1a;
        }
      }
      .mrb15 {
        margin-bottom: 15px;
      }
      .theme_color {
        color: #ff9e00;
      }
    }
    .bottom_box {
      padding-top: 40px;
      .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 36px;
      }
      .pay_item {
        height: 74px;
        box-sizing: border-box;
        border: 1px solid #f4f4f4;
        margin-bottom: 20px;
        padding-left: 32px;
        display: flex;
        align-items: center;
        &:hover {
          border-color: #ff9e00;
        }
        .circle {
          width: 10px;
          height: 10px;
          background: #f4f4f4;
          border: 1px solid #909090;
          border-radius: 50%;
          margin-right: 24px;
        }
        .img_box {
          width: 125px;
          height: 44px;
          margin-right: 18px;
        }
        .itr {
          font-size: 14px;
        }
      }
      .active {
        border-color: #ff9e00;
        .circle {
          background: #1a1a1a;
        }
      }
      .btn_box {
        text-align: right;
        .btn {
          width: 187px;
          height: 36px;
          line-height: 36px;
          padding: 0px;
          border-radius: 0px;
        }
      }
    }
    .price {
      color: #ff0000;
    }
    .tip_box {
      position: relative;
      align-self: flex-start;
    }
    .tips {
      position: absolute;
      top: 100%;
      left: 0;
      margin-top: 15px;
      color: #ff9e00;
      font-size: 14px;
    }
    /deep/ .stage {
      width: 150px;
      .el-input__inner {
        line-height: 26px;
        height: 26px;
        width: 100%;
        padding: 0 15px;
        color: #ff0000;
        font-size: 16px;
      }
    }
    .stage_dw {
      padding-left: 4px;
    }
  }
}
</style>